import { createPublicClient, fallback, http } from "viem";
import { base, mainnet } from "viem/chains";

export const baseClient = createPublicClient({
  chain: base,
  transport: fallback([
    http(import.meta.env.VITE_BASE_RPC_URL ?? "https://mainnet.base.org", { retryCount: 2 }),
    http("https://base-rpc.publicnode.com", { retryCount: 2 }),
  ]),
});

export const ethereumClient = createPublicClient({
  chain: mainnet,
  transport: fallback([
    http(import.meta.env.VITE_ETHEREUM_RPC_URL ?? "https://ethereum-rpc.publicnode.com", { retryCount: 2 }),
    http("https://eth.llamarpc.com", { retryCount: 2 }),
  ]),
});
